import React from "react";
import PropTypes from "prop-types";
import MenuList from "@material-ui/core/MenuList";
import MenuItem from "@material-ui/core/MenuItem";
import Divider from "@material-ui/core/Divider";
import { withStyles } from "@material-ui/core/styles";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faWarehouse,
  faTruck,
  faTools
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import api from "../utils/api";
import { getOfficeId } from "../utils/preferences";

const menuItemGroups = {
  "Renkaiden vaihto": {
    items: {
      "Keräile ja lähetä korjaamolle": {
        icon: faWarehouse,
        to: "/keraileJaLaheta",
        regionId: "1"
      },
      "Vastaanota korjaamolla": {
        icon: faTruck,
        to: "/vastaanotaKorjaamolla",
        regionId: "2"
      },
      "Vaihda ja lähetä varastolle": {
        icon: faTools,
        to: "/vaihdaJaLahetaVarastolle",
        regionId: "3"
      },
      "Vastaanota varastolla": {
        icon: faWarehouse,
        to: "/vastaanotaVarastolla",
        regionId: "4"
      },
      Hyllytä: {
        icon: faWarehouse,
        to: "/hyllyta",
        regionId: "5"
      }
    }
  }
};

const styles = theme => ({
  menuItem: {
    "&:focus": {
      backgroundColor: theme.palette.primary.main,
      "& $primary, & $icon": {
        color: theme.palette.common.white
      }
    },
    padding: theme.spacing(3)
  },
  primary: {},
  icon: {},
  link: {
    textDecoration: "none",
    color: theme.palette.common.black
  }
});
let selectedOfficeId = getOfficeId();
export const selectedOfficeIdChanged = newId => (selectedOfficeId = newId);
const ListItemComposition = props => {
  const { classes } = props;
  const [regions, setRegions] = React.useState([]);
  React.useEffect(() => {
    api.valueList.get("Regions").then(({ data }) => {
      setRegions(
        data.map(valueListItem => {
          const keyParts = valueListItem.key.split("_");
          return {
            officeId: keyParts[0],
            regionId: keyParts[1]
          };
        })
      );
    });
  }, [""]);
  const shouldShowLink = regionId =>
    regions.find(
      r => r.officeId === selectedOfficeId && r.regionId === regionId
    ) !== undefined;

  return (
    <MenuList style={{ width: "100%" }}>
      {Object.keys(menuItemGroups).map(migKey => {
        const mig = menuItemGroups[migKey];
        const items = mig.items;
        return [
          // <ListSubheader>
          //   <ListItemText primary={migKey} />
          // </ListSubheader>
          Object.keys(items).map(iKey => {
            const i = items[iKey];
            const shouldShow = !selectedOfficeId || shouldShowLink(i.regionId);
            return (
              shouldShow && (
                <Link
                  to={i.to}
                  className={classes.link}
                  data-selected-office={selectedOfficeId}
                >
                  <MenuItem className={classes.menuItem}>
                    <ListItemIcon className={classes.icon}>
                      <FontAwesomeIcon icon={i.icon} />
                    </ListItemIcon>
                    <ListItemText
                      classes={{ primary: classes.primary }}
                      primary={iKey}
                    />
                  </MenuItem>
                </Link>
              )
            );
          }),
          <Divider />
        ];
      })}
    </MenuList>
  );
};

ListItemComposition.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ListItemComposition);
